(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-faq"] && !Shopify.designMode) return;
  try {
    
         const faqItems = document.querySelectorAll(".faq-item");
         
         faqItems.forEach(item => {
         const btn = item.querySelector(".faq-question");
         
         btn.addEventListener("click", () => {
         // close other items
         faqItems.forEach(i => {
         if (i !== item) {
         i.classList.remove("active");
         i.querySelector(".icon").textContent = "+";
         }
         });
         
         // toggle current item
         item.classList.toggle("active");
         
         const icon = item.querySelector(".icon");
         icon.textContent = item.classList.contains("active") ? "–" : "+";
         });
         });
         
      

  } catch(e) { console.error(e); }
})();
})();
